import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface UpdateState {
  lastSeenVersion: string | null;
  setLastSeenVersion: (version: string) => void;
}

export const useUpdateStore = create<UpdateState>()(
  persist(
    (set) => ({
      lastSeenVersion: null,
      setLastSeenVersion: (version) => set({ lastSeenVersion: version }),
    }),
    {
      name: 'update-storage',
    }
  )
);